import React from "react";

import { Spinner } from "components";

const ProductsStatus = ({
    items,
    firstIndex,
    lastIndex,
    loading,
    displayedItems,
    title = "Items Overview",
}) => {
    if (loading) {
        return (
            <div className="d-flex">
                <Spinner show={loading} />
                <span className="ml-2">Loading...</span>
            </div>
        );
    }

    return (
        <>
            {items?.length > 0 ? (
                <>
                    <h4>{title}</h4>
                    <h6>Total items: {items?.length}</h6>
                    <h6>
                        Displaying: [{firstIndex} - {lastIndex}]
                    </h6>
                </>
            ) : (
                <div>
                <img style={{width: "40%"}} src="https://kvcodes.com/clients/modules/products/uploads/no-product.png" alt="" />
                {/* <h6>No items found</h6> */}
                </div>
            )}
        </>
    );
};

export default ProductsStatus;
